// boilerplate generated 2026-10-24 18:45:08
import Vue from 'vue';

import Vuex from 'vuex';
import navigation from '@/vuex/navigation.js';
import checkpoints from '@/vuex/checkpoints.js';
import context from '@/vuex/context.js';
import database from '@/vuex/database.js';
import location from '@/vuex/location.js';
import session from '@/vuex/session.js';
import datapoints from '@/vuex/datapoints.js';
import actions from '@/vuex/actions.js';
import timers from '@/vuex/timers.js';
import server from '@/vuex/server.js';
import socket from '@/vuex/socket.js';
import counter from '@/vuex/counter.mjs';

Vue.use(Vuex)
export default new Vuex.Store({
strict: true,
  modules: {
	navigation,
	checkpoints,
	context,
	database,
	location,
	session,
	datapoints,
	actions,
	timers,
	server,
	socket,
	counter,
	}
})
